<template>
  <div style="width: 800px">
    <SubJectAreaCriteria
      :Disabled="fromEdit"
      :SubjectAreaId="subjectareaid"
      :Level="level"
      :PathwayId="pathwayid"
      @subject-area-selected="subject_area_selected"
      @level-selected="level_selected"
      @pathway-selected="pathway_selected"
    ></SubJectAreaCriteria>
    <button
      class="ts-btn ts-btn-rounded ts-btn-secondary"
      @click="storeSection()"
    >
      Continue
    </button>
    <br />
    <a class="back-link" @click="goBack">
      <i class="fas fa-chevron-left"></i>Back
    </a>
    <br />
    <br />
    <br />
  </div>
</template>

<script>
import SubJectAreaCriteria from "../../../../components/ApprenticeCriteria";

export default {
  components: {
    SubJectAreaCriteria
  },
  created() {
    this.fetchSession();
    if (this.currentCriteria.id != null) {
      this.fromEdit = true;
    } else {
      this.fromEdit = false;
    }

    if (this.currentCriteria.subjectArea !== null) {
      this.subjectareaid = this.currentCriteria.subjectArea.id;
    }

    if (this.currentCriteria.level !== null) {
      this.level = parseInt(this.currentCriteria.level.name);
    }
    if (this.currentCriteria.pathway !== null) {
      this.pathwayid = this.currentCriteria.pathway.id;
    }
  },
  destroyed() {},
  destroyed() {},
  data() {
    return {
      subjectareaid: null,
      level: null,
      pathwayid: null,
      fromEdit: false
    };
  },
  watch: {},
  computed: {
    currentCriteria() {
      return this.$store.state.apprentice.current_apprentice_criteria;
    }
  },
  methods: {
    fetchSession() {
      var parsed = JSON.parse(window.sessionStorage.getItem("currentCriteria"));
      if (parsed != null) {
        this.currentCriteria.id = parsed.id;
        this.currentCriteria.subjectArea = parsed.subjectArea;
        this.currentCriteria.level = parsed.level;
        this.currentCriteria.pathway = parsed.pathway;
        this.currentCriteria.sgaHiddenExtras =
          parsed.sgaHiddenExtras == null ? null : parsed.sgaHiddenExtras;
        this.currentCriteria.sgaKnowledge =
          parsed.sgaKnowledge == null ? null : parsed.sgaKnowledge;
        this.currentCriteria.sgaSkills =
          parsed.sgaSkills == null ? null : parsed.sgaSkills;
        this.currentCriteria.sgaMindset =
          parsed.sgaMindset == null ? null : parsed.sgaMindset;
      }
    },
    storeSection() {
      window.sessionStorage.setItem(
        "currentCriteria",
        JSON.stringify(this.currentCriteria)
      );

      this.$store
        .dispatch("apprentice/validateexistinginterests", this.currentCriteria)
        .then(res => {
          if (!res || this.fromEdit) {
            this.$router.app.$emit("navigateToNextStep");
          } else {
            this.$confirm(
              `Apprenticeship criteria already exists. Please select a different combination or update an existing record.`,
              "Warning",
              {
                confirmButtonText: "OK",
                dangerouslyUseHTMLString: true,
                type: "warning",
                center: true
              }
            ).then(() => {
              return false;
            });
          }
        })
        .catch(() => {
          this.$message.error(
            `Apprenticeship criteria failed. Please contact you administrator`
          );
        });
    },
    goBack() {
      this.$router.back();
    },
    subject_area_selected(obj) {
      this.currentCriteria.subjectArea = obj.subject;
    },
    level_selected(obj) {
      this.currentCriteria.level = obj.level;
    },
    pathway_selected(obj) {
      this.currentCriteria.pathway = obj.pathway;
    }
  }
};
</script>

<style lang="scss"></style>
